var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"showbox"},[_c('v-tooltip',{attrs:{"left":"","color":"#333333"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"my-2 mr-2",attrs:{"color":"#ffffff","size":"20"}},'v-icon',attrs,false),on),[_vm._v("mdi-account-voice")])]}}])},[_c('span',[_vm._v("NAO spricht")])]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.answer)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }